import React, { useState } from 'react';
import './NetworkStatus.css';

const NetworkStatus = () => {
  const [activeTab, setActiveTab] = useState('scheduled');

  return (
    <div className="network-status-card">
      <div className="network-status-header">
        <div className="tabs">
          <span
            className={`tab ${activeTab === 'outage' ? 'active' : ''}`}
            onClick={() => setActiveTab('outage')}
          >
            Outage
          </span>
          <span
            className={`tab ${activeTab === 'scheduled' ? 'active' : ''}`}
            onClick={() => setActiveTab('scheduled')}
          >
            Scheduled Maintenance
          </span>
        </div>
      </div>

      <div className="network-status-content">
        {activeTab === 'scheduled' ? (
          <div className="maintenance-box">
            <span className="status-dot green" />
            <span>No Scheduled Maintenance</span>
          </div>
        ) : (
          <div className="maintenance-box">
            <span className="status-dot green" />
            <span>No Current Outages</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default NetworkStatus;
